import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { getArticle, getArticlesByCategory } from "../data/articles";
import ArticleCard from "../components/ArticleCard";
import NotFound from "./NotFound";

function Block({ block }) {
  switch (block.t) {
    case "lead":
      return <p className="lead">{block.text}</p>;
    case "h2":
      return <h2>{block.text}</h2>;
    case "ul":
      return (
        <ul>
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );
    default:
      return <p>{block.text}</p>;
  }
}

function ArticlePage() {
  const { slug } = useParams();
  const article = getArticle(slug);
  if (!article) return <NotFound />;

  const related = getArticlesByCategory(article.category)
    .filter((a) => a.slug !== article.slug)
    .slice(0, 3);

  return (
    <Container className="py-5">
      <Row className="">
        <Col lg={8}>
          <h1 className="fw-bold mb-4" style={{ fontSize: "clamp(1.8rem, 4vw, 2.6rem)", color: "var(--fi-dark)" }}>
            {article.emoji} {article.title}
          </h1>
        </Col>
      </Row>
      <Row className="">
          <Col lg={8} className="fi-article">
            {article.content.map((block, i) => (
              <Block key={i} block={block} />
            ))}

            <div className="fi-stat mt-5 p-4 text-start" style={{ background: "rgba(11,110,79,0.07)" }}>
              <strong>⚠️ Disclaimer:</strong> This article is for educational
              purposes only and is not financial advice. Always do your own
              research or consult a SEBI-registered advisor before investing.
            </div>
          </Col>
        </Row>

        {related.length > 0 && (
          <div className="mt-5">
            <h3 className="fw-bold mb-4">Related Articles</h3>
            <Row className="g-4">
              {related.map((a) => (
                <Col md={6} lg={4} key={a.slug}>
                  <ArticleCard article={a} />
                </Col>
              ))}
            </Row>
          </div>
        )}
    </Container>
  );
}

export default ArticlePage;
